module.exports = __webpack_public_path__ + "media/images/let-you-screen/google-icon-907898d5cefc339dbedaac9e58c87c67.svg";